module.exports = __webpack_public_path__ + "img/violet_083.726065a2.png";